import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=01655d77&scoped=true"
import script from "./welcome.vue?vue&type=script&lang=ts"
export * from "./welcome.vue?vue&type=script&lang=ts"
import style0 from "./welcome.vue?vue&type=style&index=0&id=01655d77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01655d77",
  null
  
)

export default component.exports